var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.73354 11.2695L13.5797 6.42334M18.5371 3.46582L14.4464 16.7604C14.0798 17.9518 13.8964 18.5478 13.5802 18.7454C13.306 18.9168 12.9664 18.9454 12.6677 18.8215C12.3233 18.6786 12.0438 18.1204 11.4861 17.0051L8.89517 11.8232C8.80667 11.6463 8.76238 11.5581 8.70327 11.4814C8.65082 11.4134 8.59028 11.3521 8.52223 11.2996C8.44729 11.2419 8.36064 11.1986 8.19155 11.114L2.9977 8.51709C1.8824 7.95944 1.3247 7.68035 1.18179 7.33594C1.05785 7.03725 1.08611 6.69738 1.25747 6.42312C1.45506 6.10689 2.05101 5.92317 3.24282 5.55646L16.5374 1.46582C17.4744 1.17753 17.943 1.03349 18.2595 1.14968C18.5352 1.25088 18.7525 1.46799 18.8537 1.74365C18.9698 2.05998 18.8257 2.52841 18.5377 3.46444L18.5371 3.46582Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorTg);
export default __webpack_public_path__ + "static/media/vector-tg.5d4294473a3df205474a75f431b64d58.svg";
export { ForwardRef as ReactComponent };